import React, { useState, useCallback, useEffect } from 'react';
import {
  MinChatUiProvider,
  MainContainer,
  MessageInput,
  MessageContainer,
  MessageList,
  MessageHeader
} from "@minchat/react-chat-ui";
import { useT } from './i18n';

const ChatComponent = ({
  theme = "#6ea9d7",
  currentUserId = "current-user",
  messages = [],
  onSendMessage,
  placeholder,
  headerTitle,
  showTypingIndicator = false,
  typingIndicatorContent,
}) => {
  const t = useT();

  const resolvedPlaceholder = placeholder ?? t.chat.defaultPlaceholder;
  const resolvedHeaderTitle = headerTitle ?? t.chat.defaultHeaderTitle;
  const resolvedTypingContent = typingIndicatorContent ?? t.chat.defaultTyping;

  const handleSendMessage = useCallback((inputText) => {
    if (!inputText.trim()) return;

    const newMessage = {
      id: Date.now().toString(),
      text: inputText,
      user: {
        id: currentUserId,
        name: t.chat.you,
      },
      timestamp: new Date(),
    };

    // Call external handler if provided - let parent manage state
    if (onSendMessage) {
      onSendMessage(newMessage);
    }
  }, [currentUserId, onSendMessage, t]);

  return (
    <MinChatUiProvider theme={theme}>
      <MainContainer style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <MessageContainer>
          <MessageHeader showBack={false}>
            {resolvedHeaderTitle}
          </MessageHeader>
          <MessageList
            currentUserId={currentUserId}
            messages={messages}
            showTypingIndicator={showTypingIndicator}
            typingIndicatorContent={resolvedTypingContent}
          />
          <MessageInput
            placeholder={resolvedPlaceholder}
            onSendMessage={handleSendMessage}
            showAttachButton={false}
          />
        </MessageContainer>
      </MainContainer>
    </MinChatUiProvider>
  );
};

export default ChatComponent;